// A login/logout boundary, not a consent flag. Token rotation keeps the same boundary.
export const SESSION_KEY = 'medeffects.authSession';
export const SESSION_EVENT = 'medeffects:session-changed';
let generation = 0;

export function accountId(user) {
  if (!user || (user._id && user.id && user._id !== user.id)) return null;
  const id = user._id || user.id;
  return typeof id === 'string' && id.trim() === id && id.length > 0 ? id : null;
}

function storedAccountId() {
  try { return accountId(JSON.parse(localStorage.getItem('user'))); } catch { return null; }
}

export function captureSession() {
  return {
    generation,
    stamp: localStorage.getItem(SESSION_KEY),
    userId: storedAccountId(),
    hadToken: Boolean(localStorage.getItem('accessToken')),
  };
}

export function isSessionCurrent(session) {
  return Boolean(session && session.generation === generation &&
    session.stamp === localStorage.getItem(SESSION_KEY) &&
    session.userId === storedAccountId() &&
    (!session.hadToken || localStorage.getItem('accessToken')));
}

export function advanceSession() {
  generation += 1;
  localStorage.setItem(SESSION_KEY, `${Date.now()}-${generation}-${Math.random()}`);
}

export function clearCredentials() {
  // Invalidate async work before clearing or publishing the logged-out UI.
  advanceSession();
  ['accessToken', 'refreshToken', 'user'].forEach((key) => localStorage.removeItem(key));
  window.dispatchEvent(new Event(SESSION_EVENT));
}

export function assertCurrentSession(session) {
  if (!isSessionCurrent(session)) throw new Error('Your session changed. Please sign in again.');
}
